import * as core from './core';
import dateTime from './core/date-time';

export default dateTime;

export { core };
